

import $ from "jquery";


import Splide from '@splidejs/splide';



const relatedSingles = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error("Element not found for Swiper initialization [relatedSingles-Swiper]");
    }
    let splide = new Splide(el,
        {
            autoScroll: {
                speed: -1,
            },
            autoWidth: true,
            cloneStatus: false,
            pagination: false,
            arrows: true,
            updateOnMove: true,
            gap: '2.4rem',
            autoHeight: true,


        }
    );
    let bar = splide.root.querySelector( '.recent-articles__progress-bar' );
    splide.on( 'mounted move', function () {
        var end  = splide.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( splide.index + 1 ) / end, 1 );
        bar.style.width = String( 100 * rate ) + '%';
      } );

    splide.mount();


};

export default relatedSingles;






